import { Controller } from "@hotwired/stimulus"
import Swal from "sweetalert2"

export default class extends Controller {
  static values = { message: String }
  explain() {
    Swal.fire({ title: "Coaching invoice", text: this.messageValue, icon: "info", confirmButtonText: "OK" })
  }
}
